<script setup lang="ts">
const props = defineProps({
  translationId: {
    type: String,
    required: true,
  },
  merchantId: {
    type: String,
    required: false,
    default: "",
  },
});

const { sourcesUrl } = useRuntimeConfig().public;
const { getMerchantAttributes } = useLuxuryDesign();
const descriptionAttributes = computed(() =>
  getMerchantAttributes(props.merchantId)
);
</script>
<template>
  <div
    v-bind="descriptionAttributes"
    class="grow px-7 py-5 border-b-2 border-primary-900 lg:max-h-82 md:max-h-72 max-h-60 overflow-y-scroll card-description">
    <p class="text-neutral-200 font-bold text-base">
      {{ $t("main.storeDetail.description") }}
    </p>
    <ClientOnly>
      <p
        class="text-neutral-300 font-light"
        v-html="
          $t(`${translationId}.description`, {
            GFAL_SOURCES_URI: sourcesUrl + '/marketplace',
          })
        "></p>
    </ClientOnly>
  </div>
</template>
